export default {
    methods:{
        khmerCurrencyFormat(amount) {
            amount = Number(amount ?? 0);
            return amount.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },
        currencyFormat(amount) {
            return Number(amount ?? 0).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
        },
        currencySymbol() {
            return "$";
        },
        currencyFormatWithSymbol(amount) {
            return this.currencySymbol() + this.currencyFormat(amount);
        },
    }
}
